import React from 'react'
import './MoreCTA.scss'

const MoreCTA = ({text, style, url}) => <a href={url} style={style} className="more-cta">{text}</a>

export default MoreCTA


// WEBPACK FOOTER //
// ./src/components/MoreCTA/index.js